import { render } from "./RestaurantCart.vue?vue&type=template&id=309480e0&scoped=true&ts=true"
import script from "./RestaurantCart.vue?vue&type=script&lang=ts"
export * from "./RestaurantCart.vue?vue&type=script&lang=ts"

import "./RestaurantCart.vue?vue&type=style&index=0&id=309480e0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309480e0"]])

export default __exports__